import { Injectable } from '@angular/core';
import { GetHomesSuccess, HomesActions } from '@library/store/homes/homes.action';
import { SchedulesService } from '@library/store/schedules/schedules.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { CreateNewSchedule, CreateNewScheduleFailure, CreateNewScheduleSuccess, LoadScheduleVeluxSuccess, UpdateSchedule, UpdateScheduleFailure, UpdateScheduleSuccess } from './schedules.action';

@Injectable()
export class SchedulesEffectsVelux {
  constructor(
    private readonly actions$: Actions,
    private readonly schedulesService: SchedulesService,
  ) { }

  loadSchedule$ = createEffect(() => this.actions$.pipe(
    ofType<GetHomesSuccess>(HomesActions.getHomesSuccess),
    switchMap((action) => {
      return [LoadScheduleVeluxSuccess({ homes: action.payload })];
    }),
  ));

  createSchedule$ = createEffect(() => this.actions$.pipe(
    ofType(CreateNewSchedule),
    switchMap((action) => {
      if (action.data.isNew) {
        return this.schedulesService.createNewSchedule(action.data).pipe(
          map(() => CreateNewScheduleSuccess({ data: action.data })),
          catchError(({ error }) => of(CreateNewScheduleFailure({ error }))),
        );
      }
      else {
        return this.schedulesService.modifySchedule(action.data).pipe(
          map(() => CreateNewScheduleSuccess({ data: action.data })),
          catchError(({ error }) => of(CreateNewScheduleFailure({ error }))),
        );
      }
    }),
  ));

  updateSchedule$ = createEffect(() => this.actions$.pipe(
    ofType(UpdateSchedule),
    switchMap((action) => {
      return this.schedulesService.modifySchedule(action.data).pipe(
        map(() => UpdateScheduleSuccess({ data: action.data })),
        catchError(({ error }) => of(UpdateScheduleFailure({ error }))),
      );
    }),
  ));
}
